import script from "./DashboardCount.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardCount.vue?vue&type=script&setup=true&lang=js"

import "./DashboardCount.vue?vue&type=style&index=0&id=31d616b4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31d616b4"]])

export default __exports__